import { PropsWithChildren } from "react";

import logo from "../../assets/logo-horz-full-color-opt.svg";
import styles from "./errors.module.css";

export const ErrorBase = ({ children }: PropsWithChildren) => {
  return (
    <div className={styles.container}>
      <img src={logo} alt="SageSure Logo" width={224} height={50} />
      {children}
    </div>
  );
};
